import type { SVGProps } from 'react';

export function BankIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.97 19.5a1.5 1.5 0 0 1 0 3H2.03a1.5 1.5 0 0 1 0-3zM5.353 10.443a1.5 1.5 0 0 1 1.5 1.5v4.705a1.5 1.5 0 0 1-3 0v-4.705a1.5 1.5 0 0 1 1.5-1.5m4.432 0a1.5 1.5 0 0 1 1.5 1.5v4.705a1.5 1.5 0 0 1-3 0v-4.705a1.5 1.5 0 0 1 1.5-1.5m4.431 0a1.5 1.5 0 0 1 1.5 1.5v4.705a1.5 1.5 0 0 1-3 0v-4.705a1.5 1.5 0 0 1 1.5-1.5m4.43 0a1.5 1.5 0 0 1 1.5 1.5v4.705a1.5 1.5 0 0 1-3 0v-4.705a1.5 1.5 0 0 1 1.5-1.5M12.007.5a3.7 3.7 0 0 1 1.632.387l.001-.001 8.714 4.299c1.923.95 1.296 3.905-.907 3.906H2.555c-2.212 0-2.823-2.959-.91-3.905h.002L10.36.88l.005-.002c.51-.25 1.072-.38 1.64-.378" />
    </svg>
  );
}
